import React from 'react';
import dayjs from 'dayjs';
import Footer, { FooterCenter } from '../../../components/layouts/Footer/Footer';

const DefaultFooterTemplate = () => {
	return (
		<Footer>
			<FooterCenter className='text-zinc-500'>
				<div className='text-center text-xs text-gray-500'>© 2025 Therapix Technolabs Inc. All rights reserved.</div>
			</FooterCenter>
		</Footer>
	);
};

export default DefaultFooterTemplate;
